import {InjectionToken} from '@angular/core';

export enum ApplicationMode {
  'frontend' = 'frontend',
  'backend' = 'backend',
}

export const APPLICATION_MODE = new InjectionToken<ApplicationMode>('ApplicationMode');
